// Main logo for expanded sidebar
import MainLogo from './mainlogo.png';
// Small logo for collapsed sidebar  
import Logo from './logo.svg';
// Default avatar
import DefaultAvatar from './logo.svg';

import banner from './login.jpg'

export const assets = {
  MainLogo,
  Logo,
  DefaultAvatar, banner,
};